import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

export const AddOutlineIcon: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <mask
      id="mask0_3060_719"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="25"
    >
      <rect y="0.5" width="24" height="24" fill="white" />
    </mask>
    <g mask="url(#mask0_3060_719)">
      <path
        d="M11.25 13.25H6.25C6.0375 13.25 5.85942 13.1781 5.71575 13.0342C5.57192 12.8904 5.5 12.7122 5.5 12.4997C5.5 12.2871 5.57192 12.109 5.71575 11.9655C5.85942 11.8218 6.0375 11.75 6.25 11.75H11.25V6.75C11.25 6.5375 11.3219 6.35942 11.4658 6.21575C11.6096 6.07192 11.7878 6 12.0003 6C12.2129 6 12.391 6.07192 12.5345 6.21575C12.6782 6.35942 12.75 6.5375 12.75 6.75V11.75H17.75C17.9625 11.75 18.1406 11.8219 18.2843 11.9658C18.4281 12.1096 18.5 12.2878 18.5 12.5003C18.5 12.7129 18.4281 12.891 18.2843 13.0345C18.1406 13.1782 17.9625 13.25 17.75 13.25H12.75V18.25C12.75 18.4625 12.6781 18.6406 12.5342 18.7843C12.3904 18.9281 12.2122 19 11.9997 19C11.7871 19 11.609 18.9281 11.4655 18.7843C11.3218 18.6406 11.25 18.4625 11.25 18.25V13.25Z"
        fill="currentColor"
      />
    </g>
  </Icon>
);

export const EditOutlineIcon: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M21.0063 7.25242L16.8096 3.05664C16.5244 2.77523 16.1445 2.61952 15.7459 2.62515C15.3453 2.62796 14.9692 2.78743 14.6915 3.06883L3.43431 14.327C3.1529 14.6093 2.99907 14.9846 3 15.3813V19.5743C3 20.4016 3.67351 21.0751 4.50084 21.0751H8.69663C9.08778 21.0751 9.47143 20.9166 9.75003 20.6399L21.0185 9.37048C21.5991 8.78046 21.5916 7.82837 21.0063 7.25242ZM8.69287 19.5743H4.50084L4.49709 15.387L12.7583 7.13048L16.9465 11.3188L8.69287 19.5743ZM18.0084 10.2588L13.8201 6.07051L15.7609 4.13068L19.9445 8.32271L18.0084 10.2588Z"
    />
  </Icon>
);

export const DeleteOutlineIcon: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5.75C3 5.33579 3.33579 5 3.75 5H20.25C20.6642 5 21 5.33579 21 5.75C21 6.16421 20.6642 6.5 20.25 6.5H3.75C3.33579 6.5 3 6.16421 3 5.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 2.75C7.5 2.33579 7.83579 2 8.25 2H15.75C16.1642 2 16.5 2.33579 16.5 2.75C16.5 3.16421 16.1642 3.5 15.75 3.5H8.25C7.83579 3.5 7.5 3.16421 7.5 2.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 5C5.66421 5 6 5.33579 6 5.75V20H18V5.75C18 5.33579 18.3358 5 18.75 5C19.1642 5 19.5 5.33579 19.5 5.75V20C19.5 20.3978 19.342 20.7794 19.0607 21.0607C18.7794 21.342 18.3978 21.5 18 21.5H6C5.60218 21.5 5.22065 21.342 4.93934 21.0607C4.65804 20.7794 4.5 20.3978 4.5 20V5.75C4.5 5.33579 4.83579 5 5.25 5Z"
      fill="currentColor"
    />
  </Icon>
);

export const DuplicateOutlineIcon: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <mask
      id="mask0_2866_236959"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_2866_236959)">
      <path
        d="M12.75 10.75H14.25V8.75H16.25V7.25H14.25V5.25H12.75V7.25H10.75V8.75H12.75V10.75ZM10.75 14.75H16.25V13.25H10.75V14.75ZM8.30775 18.5C7.80258 18.5 7.375 18.325 7.025 17.975C6.675 17.625 6.5 17.1974 6.5 16.6923V3.30775C6.5 2.80258 6.675 2.375 7.025 2.025C7.375 1.675 7.80258 1.5 8.30775 1.5H15.25L20.5 6.75V16.6923C20.5 17.1974 20.325 17.625 19.975 17.975C19.625 18.325 19.1974 18.5 18.6923 18.5H8.30775ZM8.30775 17H18.6923C18.7693 17 18.8398 16.9679 18.9038 16.9038C18.9679 16.8398 19 16.7692 19 16.6923V7.5L14.5 3H8.30775C8.23075 3 8.16025 3.03208 8.09625 3.09625C8.03208 3.16025 8 3.23075 8 3.30775V16.6923C8 16.7692 8.03208 16.8398 8.09625 16.9038C8.16025 16.9679 8.23075 17 8.30775 17ZM4.30775 22.5C3.80258 22.5 3.375 22.325 3.025 21.975C2.675 21.625 2.5 21.1974 2.5 20.6923V7.5H4V20.6923C4 20.7693 4.03208 20.8398 4.09625 20.9038C4.16025 20.9679 4.23075 21 4.30775 21H14.5V22.5H4.30775Z"
        fill="currentColor"
      />
    </g>
  </Icon>
);
